import request from '../utils/request'
import global from '../config/global'
import coreServices from './core'
import projectServices from './project'

function list(params = {}) {
  return request({
    url: global.endpoint.WORKSPACES,
    method: 'get',
    params
  })
}

function update(id, data = {}) {
  return request({
    url: global.endpoint.WORKSPACE.replace(':id', id),
    method: 'put',
    data
  })
}

function remove(id) {
  return request({
    url: global.endpoint.WORKSPACE.replace(':id', id),
    method: 'delete',
  })
}

function access_logs(id, params = {}) {
  return request({
    url: global.endpoint.WORKSPACE_ACCESS_LOGS.replace(':id', id),
    method: 'get',
    params
  })
}

function members(id, params = {}) {
  return request({
    url: global.endpoint.WORKSPACE_MEMBERS.replace(':id', id),
    method: 'get',
    params
  })
}

function create_member(id, data) {
  return request({
    url: global.endpoint.WORKSPACE_MEMBERS.replace(':id', id),
    method: 'post',
    data
  })
}

async function create_members(id, data) {
  const payload = await Promise.all(data.map(async m => {
    const authPayload = await coreServices.auth_payload(m, false)
    return {
      ...authPayload,
      full_name: m.username,
      role: 'member'
    }
  }))
  return request({
    url: global.endpoint.WORKSPACE_CREATE_MEMBERS.replace(':id', id),
    method: 'post',
    data: payload
  })
}

function remove_member(id, memberId) {
  return request({
    url: global.endpoint.WORKSPACE_MEMBER.replace(':id', id).replace(':member_id', memberId),
    method: 'delete',
  })
}

function reinvite(id, memberId) {
  return request({
    url: global.endpoint.WORKSPACE_MEMBER_REINVITE.replace(':id', id).replace(':member_id', memberId),
    method: 'post',
  })
}

async function create_projects(id, data) {
  const payload = await Promise.all(data.map(async p => await projectServices.get_payload(p, id)))
  return request({
    url: global.endpoint.WORKSPACE_CREATE_PROJECTS.replace(':id', id),
    method: 'post',
    data: {
      projects: payload
    }
  })
}

async function import_data(id, data) {
  return request({
    url: global.endpoint.WORKSPACE_IMPORT.replace(':id', id),
    method: 'post',
    data: data
  })
}

export default {
  list,
  update,
  remove,
  access_logs,
  members,
  create_member,
  create_members,
  remove_member,
  reinvite,
  create_projects,
  import_data,
}
